// src/components/MovingText.jsx
import React from "react";
import { motion } from "framer-motion";

const movingText = [
  "Full-stack Engineer",
  "Performance, Reliability, Precision",
  "Python • TypeScript • React • Node.js",
  "AWS • Azure • DevOps • CI/CD",
  "Machine Learning • LoRA Training",
  "GenAI Prototyping & RAG Systems",
  "Built a $5000 MRR business on accident",
  "Dubai Golden Visa Recipient",
  "Data Centers • Infrastructure • Automation",
  "Product Architecture & Delivery"
];


const MovingText = () => {
  // Duplicate the array so the loop looks continuous
  const items = [...movingText, ...movingText];

  return (
    <section className="moving-strip">
      <div className="moving-strip-inner">
        <motion.div
          className="moving-strip-track"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          {items.map((text, index) => (
            <span key={index} className="moving-strip-item">
              {text}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default MovingText;
